/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Spin,
  Card,
  Tabs,
  message,
} from 'antd';
import {
  ArrowLeftOutlined,
  EditOutlined,
  UserOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  SettingOutlined,
  SolutionOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import FormSubmitCustomControls from 'components/FormSubmitCustomControls';
import FormSubmitControls from 'components/FormSubmitControls';
import DireccionEntidad from 'components/Entity/DireccionEntidad';
import AvatarUploader from 'components/AvatarUploader';
import LadaNumero from 'components/LadaNumero';
import Administrators, { tabAdministradoresPermission } from 'components/Entity/Administrators';
import Configurations, { tabConfigEntidadPermission } from 'components/Entity/Configurations/index';
import ConfiguracionesUR, { tabConfigURsPermission } from 'components/Entity/ConfiguracionesUR';
import RegistrosPatronales, { tabRegistroPatronalPermission } from 'components/Entity/RegistrosPatronales';
import Select from 'components/Select';
import { onError, onSuccess } from 'utils/handlers';
import { generateRFCRules } from 'utils/rules';
import { getEntidad, patchEntidad, postEntidad } from 'api/estructuraOrganizacional/entidad';
import { postConfiguracionDeEntidad } from 'api/estructuraOrganizacional/configuracionDeEntidad';
import { postURAdministrador } from 'api/estructuraOrganizacional';
import { getRegimenesFiscales } from 'api/nominas/entidades/regimenesFiscales';
import { getDireccion } from 'api/catalogos/direcciones';
import { getPaises } from 'api/catalogos/paises';
import { getConceptosDeUnidadResponsable } from 'api/contabilidad';
import { getUsuarios } from 'api/usuarios/usuarios';
import { selectMonedas } from 'store/catalogos';
import { isEqual } from 'lodash';
import {
  getMonedas,
  getClasificacionesAdministrativas,
  getCodigosPostales,
} from 'api/catalogos';
import {
  seelectEntidad,
  selectPeriodoFiscalSelected,
  updateEntidadInfo,
} from 'store/auth';
import EntidadMunicipalOtrosDatos, { tabOtrosDatosPermission } from 'components/Entity/EntidadMunicipalOtrosDatos';

const { TabPane } = Tabs;
export const entidadPermission = {
  permissionModel: 'entidadmunicipal',
  tabsModels: [
    tabAdministradoresPermission,
    tabConfigEntidadPermission,
    tabConfigURsPermission,
    tabRegistroPatronalPermission,
    tabOtrosDatosPermission,
  ],
};

const onErrorFields = (
  err,
  setLoading = null,
  formsInstances = [],
  setCurrentTabKey,
) => {
  if (typeof setLoading === 'function') {
    setLoading(false);
  }
  const errorKeys = err.errorFields.map((e) => e.name[0]);
  const formWithErrors = formsInstances.find(
    (obj) => obj.tabFields.some(
      (val) => errorKeys.includes(val),
    ),
  );
  if (formWithErrors) {
    setTimeout(() => {
      if (typeof setCurrentTabKey === 'function') {
        setCurrentTabKey(formWithErrors.tabKey);
      }
    });
  }
};

const EntidadMunicipal = ({ permission, addressPermission }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const monedas = useSelector(selectMonedas);
  const [form] = Form.useForm();
  const [formDireccion] = Form.useForm();
  const [formConfigurations] = Form.useForm();
  const [formConfigurationsUR] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [disabled, setDisabled] = useState(true);
  const [regimenesFiscales, setRegimenesFiscales] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [clasificacionesAdministrativas, setClasificacionesAdministrativas] = useState([]);
  const [conceptoUR, setConceptoUR] = useState([]);
  const [coloniasCargadas, setColoniasCargadas] = useState([]);
  const [paises, setPaises] = useState([]);
  const periodoFiscalSelected = useSelector(selectPeriodoFiscalSelected);
  const entidad = useSelector(seelectEntidad, isEqual);

  const requiredFormStructure = [
    {
      parentTabKey: 'general',
      tabKey: 'general',
      tabFields: ['nombre', 'RFC', 'razon_social', 'regimen_fiscal'],
    },
    {
      parentTabKey: 'direccion',
      tabKey: 'direccion',
      tabFields: ['colonia', 'numero_exterior', 'tipo_de_vialidad', 'calle_principal'],
    },
    {
      parentTabKey: 'configurations',
      tabKey: 'configurations',
      tabFields: ['moneda', 'utilizar_redondeo'],
    },
    {
      parentTabKey: 'configuracionesUR',
      tabKey: 'configuracionesUR',
      tabFields: ['periodo_fiscal', 'clasificacion_administrativa', 'concepto_de_ur'],
    },
  ];

  const loadDireccion = async () => {
    const _direccion = await getDireccion(entidad.direccion.id);
    const _codigoPostal = _direccion.codigo_postal;
    const _codigosPostales = await getCodigosPostales({ d_codigo: _codigoPostal.d_codigo });
    if (_codigosPostales.length > 0) {
      const coloniasArr = _codigosPostales.map((item) => ({
        id: item.id,
        colonia: item.d_asenta,
      }));
      setColoniasCargadas(coloniasArr);
    } else {
      setColoniasCargadas([]);
    }
    formDireccion.setFieldsValue(_direccion);
    formDireccion.setFieldValue('d_codigo', _codigoPostal.d_codigo);
    formDireccion.setFieldValue('estado', _codigoPostal.municipio?.estado.nombre_de_AGEE);
    formDireccion.setFieldValue('municipio', _codigoPostal.municipio?.nom_mun);
  };

  const fetchData = async () => {
    setLoading(true);
    const [
      _entidad,
      _clasificacionesAdministrativas,
      _conceptoUR,
    ] = await Promise.all([
      getEntidad(dispatch),
      getClasificacionesAdministrativas(),
      getConceptosDeUnidadResponsable(),
    ]);
    setClasificacionesAdministrativas(_clasificacionesAdministrativas);
    setConceptoUR(_conceptoUR);
    if (_entidad.direccion?.id) {
      loadDireccion();
    } else {
      formDireccion.resetFields();
    }
    form.setFieldsValue(_entidad);
    formConfigurations.setFieldsValue({
      ..._entidad.configuracion,
      moneda: _entidad.configuracion.moneda?.id,
    });
    formConfigurationsUR.setFieldsValue({ ...entidad.configuracion_de_ur });
    setLoading(false);
  };

  const onCancel = () => {
    setDisabled(true);
    fetchData();
  };

  const onFinish = async (_continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formDireccion.validateFields();
      await formConfigurations.validateFields();
      await formConfigurationsUR.validateFields();

      const values = form.getFieldsValue();
      const direccionValues = formDireccion.getFieldsValue();
      const entidadValues = {
        ...values,
        direccion: {
          ...direccionValues,
          codigo_postal: direccionValues.codigo_postal.id || direccionValues.codigo_postal,
        },
      };
      const configValues = formConfigurations.getFieldsValue();
      const configURValues = formConfigurationsUR.getFieldsValue();
      configURValues.entidad = entidad.id;
      const isPatch = !!values.id;
      const updated = isPatch ? await patchEntidad(entidadValues) : await postEntidad(entidadValues);
      if (updated) {
        const [
          _configEntidad,
          _configUR,
        ] = await Promise.all([
          postConfiguracionDeEntidad(configValues, dispatch),
          postURAdministrador(configURValues),
        ]);
        if (_configEntidad && _configUR) {
          dispatch(updateEntidadInfo({
            ...updated,
            configuracion: _configEntidad,
            configuracion_de_ur: _configUR,
          }));
        } else {
          throw new Error('Ha ocurrido un error y no se han guardado sus cambios de configuración');
        }
        if (!_continue) {
          await fetchData();
          formConfigurationsUR.setFieldsValue(configURValues);
          onSuccess({}, 'Editado exitosamente.');
        } else {
          onCancel();
        }
      } else {
        throw new Error('Ha ourrido un error y no se han guardado sus cambios');
      }
      setLoading(false);
      return true;
    } catch (err) {
      if (err.errorFields) {
        onErrorFields(err, setLoading, requiredFormStructure, setCurrentTabKey);
        message.warn('Favor de corregir los errores señalados.');
      } else {
        onError(err, setLoading);
      }
      return false;
    }
  };

  useEffect(() => {
    let mounted = true;
    const _fetchData = async () => {
      setLoading(true);
      const [
        _entidad,
        _regimenesFiscales,
        _usuarios,
        _clasificacionesAdministrativas,
        _conceptoUR,
        _paises,
      ] = await Promise.all([
        getEntidad(),
        getRegimenesFiscales(),
        getUsuarios(),
        getClasificacionesAdministrativas(),
        getConceptosDeUnidadResponsable(),
        getPaises(),
        getMonedas(dispatch, monedas),
      ]);
      if (mounted) {
        setRegimenesFiscales(_regimenesFiscales);
        setUsuarios(_usuarios);
        setClasificacionesAdministrativas(_clasificacionesAdministrativas);
        setConceptoUR(_conceptoUR);
        setPaises(_paises);
        if (_entidad.direccion?.id) {
          loadDireccion();
        } else {
          setColoniasCargadas([]);
        }
        form.setFieldsValue(_entidad);
        formConfigurations.setFieldsValue({
          ..._entidad.configuracion,
          moneda: _entidad.configuracion.moneda?.id,
        });
        formConfigurationsUR.setFieldsValue({ ...entidad.configuracion_de_ur });
        setLoading(false);
      }
    };
    _fetchData();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const rules = {
    RFC: generateRFCRules({ required: true, tipoDePersona: 2 }),
    required: [{ required: true }],
  };

  return (
    <Row align="center" justify="center" className="container">
      <Col span={24}>
        <Spin tip="Cargando..." spinning={loading}>
          <Card
            className="form-container"
            title="Entidad Pública"
            extra={disabled ? (
              <FormSubmitCustomControls
                controls={[
                  {
                    onClick: () => navigate('/dashboard'),
                    icon: <ArrowLeftOutlined />,
                    text: 'Regresar al Dashboard',
                  },
                  {
                    onClick: () => setDisabled(false),
                    icon: <EditOutlined />,
                    text: 'Editar',
                    disabled: !permission.change,
                  },
                ]}
              />
            ) : (
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancel}
                mutable={!disabled}
                onCancelText="Volver"
                onFinishText="Guardar y continuar"
              />
            )}
            bordered={false}
          >
            <Tabs
              onChange={setCurrentTabKey}
              activeKey={currentTabKey}
              type="card"
            >
              <TabPane
                tab={(
                  <span>
                    <InfoCircleOutlined />
                    Información General
                  </span>
                )}
                key="general"
              >
                <Form
                  layout="vertical"
                  form={form}
                  // onFinish={getOnFinish}
                  scrollToFirstError
                >
                  <Row gutter={10} style={{ padding: 20 }}>
                    <Col
                      xs={24}
                      sm={24}
                      md={8}
                      lg={6}
                    >
                      <AvatarUploader
                        disabled={disabled}
                        imageURL={form.getFieldValue('logotipo')}
                        formItemLabel="Logotipo Oficial"
                        formItemName="logotipo"
                        form={form}
                      />
                    </Col>
                    <Col
                      xs={24}
                      sm={24}
                      md={16}
                      lg={18}
                    >
                      <Row gutter={10}>
                        <Col
                          xs={24}
                          sm={24}
                          md={12}
                          xl={8}
                          xxl={8}
                        >
                          <Form.Item
                            name="nombre"
                            rules={rules.required}
                            label="Nombre"
                          >
                            <Input allowClear disabled={disabled} />
                          </Form.Item>
                        </Col>
                        <Col
                          xs={24}
                          sm={24}
                          md={12}
                          xl={8}
                          xxl={8}
                        >
                          <Form.Item
                            name="RFC"
                            label="RFC"
                            rules={rules.RFC}
                          >
                            <Input
                              className="upper"
                              maxLength={13}
                              disabled={disabled}
                            />
                          </Form.Item>
                        </Col>
                        <LadaNumero
                          rules={rules}
                          form={form}
                          breakPoints={{
                            md: 24,
                            lg: 12,
                            xl: 8,
                            xxl: 8,
                          }}
                          disabled={disabled}
                          hasFeedback={!disabled}
                        />
                        <Col
                          xs={24}
                          sm={24}
                          md={24}
                          lg={12}
                          xl={8}
                          xxl={8}
                        >
                          <Form.Item
                            name="razon_social"
                            label="Razón Social"
                            rules={rules.required}
                          >
                            <Input allowClear disabled={disabled} />
                          </Form.Item>
                        </Col>
                        <Col
                          xl={8}
                        >
                          <Form.Item
                            name="regimen_fiscal"
                            label="Régimen Fiscal"
                            rules={rules.required}
                          >
                            <Select
                              keyProp="id"
                              dataSource={regimenesFiscales}
                              render={(data) => `${data?.clave} - ${data?.nombre}`}
                              allowClear
                              disabled={disabled}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Form.Item hidden name="id">
                    <Input allowClear />
                  </Form.Item>
                  <Form.Item hidden>
                    <Button htmlType="submit" />
                  </Form.Item>
                </Form>
              </TabPane>
              {permission.tabs[tabAdministradoresPermission.model].view && (
                <TabPane
                  tab={(
                    <span>
                      <UserOutlined />
                      Administradores
                    </span>
                  )}
                  key="administradores"
                  forceRender
                >
                  <Administrators
                    disabled={disabled}
                    permission={permission.tabs[tabAdministradoresPermission.model]}
                    usuarios={usuarios}
                  />
                </TabPane>
              )}
              {addressPermission.view && (
                <TabPane
                  tab={(
                    <span>
                      <EnvironmentOutlined />
                      Dirección
                    </span>
                  )}
                  key="direccion"
                  forceRender
                >
                  <Col span={24}>
                    <DireccionEntidad
                      formDireccion={formDireccion}
                      rules={rules}
                      coloniasCargadas={coloniasCargadas}
                      paises={paises}
                      mutable={!disabled}
                      permission={addressPermission}
                    />
                  </Col>
                </TabPane>
              )}
              {permission.tabs[tabConfigEntidadPermission.model].view && (
                <TabPane
                  tab={(
                    <span>
                      <SettingOutlined />
                      Configuraciones
                    </span>
                  )}
                  key="configurations"
                  forceRender
                >
                  <Configurations
                    setLoading={setLoading}
                    form={formConfigurations}
                    monedas={monedas}
                    disabled={disabled}
                    permission={permission.tabs[tabConfigEntidadPermission.model]}
                  />
                </TabPane>
              )}
              {permission.tabs[tabConfigURsPermission.model].hasAllViewPermission && (
                <TabPane
                  tab={(
                    <span>
                      <SettingOutlined />
                      Configuración de URs
                    </span>
                  )}
                  key="configuracionesUR"
                  forceRender
                >
                  <ConfiguracionesUR
                    disabled={disabled}
                    form={formConfigurationsUR}
                    clasificacionesAdministrativas={clasificacionesAdministrativas}
                    conceptoUR={conceptoUR}
                    periodoFiscalSelected={periodoFiscalSelected}
                    permission={permission.tabs[tabConfigURsPermission.model]}
                  />
                </TabPane>
              )}
              <TabPane
                tab={(
                  <span>
                    <SolutionOutlined />
                    Registro Patronal
                  </span>
                )}
                key="registroPatronal"
                forceRender
              >
                <RegistrosPatronales permission={permission.tabs[tabConfigURsPermission.model]} />
              </TabPane>
              <TabPane
                tab={(
                  <span>
                    <FileTextOutlined />
                    Otros Datos
                  </span>
                )}
                key="otrosDatos"
                forceRender
              >
                <EntidadMunicipalOtrosDatos permission={permission.tabs[tabOtrosDatosPermission.model]} />
              </TabPane>
            </Tabs>
          </Card>
        </Spin>
      </Col>
    </Row>
  );
};

export default EntidadMunicipal;
